export default {
      id: "support-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.svg#support",
      toString: function () {
        return this.url;
      }
    }